/*
    Archivo de configuraciones globales que pueden variar para cada programador.

    Recordatorios:
        * NO mover o eliminar este archivo, solo copiar en src/app y quitar extension .txt
        * Si se agrega alguna configuración nueva en src/app/config.ts (ignorado por git),
        tambien agregarlas a src/assets/config.ts.txt (seguido por git) para asi todos tengan
        las configuraciones
*/
export const API_URL: string = 'https://1819.grupoaaf.com.ar:3002';
//export const API_URL: string = 'http://25.20.238.209:10000'; //Produccion
